module.exports = __webpack_public_path__ + "static/img/pic_no_network.405ed47.svg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/previous/icons/pic_no_network.svg
// module id = 962
// module chunks = 2